// removed by extract-text-webpack-plugin
module.exports = {"picker":"_3ErKGR792jzcgJ_UAfLtWd","pick":"_1cXia5t8ji_a3-7v4fZyXE"};


//////////////////
// WEBPACK FOOTER
// ./app/components/RawMaterialPicker/style.scss
// module id = 1050
// module chunks = 0